import { render, staticRenderFns } from "./borrowingList.vue?vue&type=template&id=c951b9ea&scoped=true"
import script from "./borrowingList.vue?vue&type=script&lang=js"
export * from "./borrowingList.vue?vue&type=script&lang=js"
import style0 from "./borrowingList.vue?vue&type=style&index=0&id=c951b9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c951b9ea",
  null
  
)

export default component.exports